import { EditOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

import {
  IS_DELETED,
  U_ACTION,
  U_COUNT_CONSTANTS_PAYMENTS,
  U_DESCRIPTION,
  U_KEY,
  U_KPP,
  U_NAME,
  U_TAX_PAYER_ID,
} from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NLegalEntities } from '@app/types/LegalEntities';
import { transformBigIntToString } from '@app/utils';

export const adaptDataToTable = (
  data: NLegalEntities.ModelLegalEntity[],
  hasUserRightToEditLegalEntities: boolean,
  handleEdit: (id: number) => void
) => {
  return data.map((legalEntities) => {
    const {
      Id,
      Name,
      Description,
      Kpp,
      CountConstantsPayments,
      TaxPayerId,
      IsDeleted,
    } = legalEntities;

    return {
      [U_KEY]: String(Id),
      [U_NAME]: (
        <>
          {IsDeleted ? (
            <div style={{ opacity: 0.5 }}>
              {generateSpanWithDataTestId(Name, 'legal-entity-name')}
              <span style={{ color: 'red' }} data-testid="archive-legal-entity">
                <br />В архиве
              </span>
            </div>
          ) : (
            <Link to={`/legal-entities/edit/?id=${Id}`}>
              {generateSpanWithDataTestId(Name, 'legal-entity-name')}
            </Link>
          )}
        </>
      ),
      [U_TAX_PAYER_ID]: (
        <>
          {TaxPayerId && (
            <div style={{ opacity: IsDeleted ? 0.5 : 1 }}>
              {generateSpanWithDataTestId(
                transformBigIntToString(TaxPayerId),
                'tin'
              )}
            </div>
          )}
        </>
      ),
      [U_KPP]: (
        <div style={{ opacity: IsDeleted ? 0.5 : 1 }}>
          {generateSpanWithDataTestId(
            Kpp?.toString(),
            'tax-registration-number'
          )}
        </div>
      ),
      [U_DESCRIPTION]: (
        <div style={{ opacity: IsDeleted ? 0.5 : 1 }}>
          {generateSpanWithDataTestId(Description, 'comment')}
        </div>
      ),
      [U_COUNT_CONSTANTS_PAYMENTS]: (
        <div style={{ opacity: IsDeleted ? 0.5 : 1 }}>
          {generateSpanWithDataTestId(
            CountConstantsPayments,
            'payment-account'
          )}
        </div>
      ),
      [U_ACTION]: (
        <>
          {IsDeleted || !hasUserRightToEditLegalEntities ? (
            ''
          ) : (
            <Space style={{ opacity: IsDeleted ? 0.5 : 1 }}>
              <Tooltip title="Редактировать">
                <Button
                  icon={<EditOutlined />}
                  onClick={() => handleEdit(Id)}
                  data-testid="edit-legal-entity"
                />
              </Tooltip>
            </Space>
          )}
        </>
      ),
      [IS_DELETED]: IsDeleted,
    };
  });
};
